/**
 * Collection Slider component
 * 
 * @module collection-slider
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'collection-slider';

if (!customElements.get(customElements.component)) {

    class collectionSlider extends HTMLElement {

        /**
         * Collection Slider constructor
         * 
         * @constructor
         */
        constructor() {

            super();

            let container = this.querySelector('[data-collection-slider]');
            container.classList.toggle("appear");
        }
    }

    customElements.define(customElements.component, collectionSlider);
}

